module.exports = __webpack_public_path__ + "static/media/it_solution_img.f95666ad.avif";